/**
 * Interface to configure of user-profile
 * */

export class UserProfileConfig {
  public username: string | null = null;
  public name: string | null = null;
  public surname: string | null = null;
  public email: string | null = null;
  public info: string | null = null;
  public address: string | null = null;
  public groups!: UserGroupListItem[];
  public permissions!: UserPermissionListItem[];
  public expired: string | null = null;

  constructor() {}
}

export class UserPermissionListItem {
  public id!: string;
  public name: string | null = null;
  public description: string | null = null;
}

export class UserGroupListItem {
  public id!: string;
  public name: string | null = null;
}
